import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { da } from 'date-fns/locale';
import { Validators } from 'ngx-editor';
import { ToastrService } from 'ngx-toastr';
import { ApiEntryControlService } from 'src/app/modules/entry-control/api-entry-control.service';
import { Facility } from 'src/app/modules/entry-control/interfaces/facility';
import { RoundsType } from 'src/app/modules/entry-control/interfaces/rounds_type';
import { formatDate } from '@angular/common'


import { MatSnackBar } from '@angular/material/snack-bar';
import {
  DndDropEvent,
} from 'ngx-drag-drop';
import { RoundsTags } from 'src/app/modules/entry-control/interfaces/rounds_tags';
import { RoundsConfiguration } from 'src/app/modules/entry-control/interfaces/rounds_configuration';


@Component({
  selector: 'app-edit-scheduled-rounds',
  templateUrl: './edit-scheduled-rounds.component.html',
  styleUrls: ['./edit-scheduled-rounds.component.css']
})
export class EditScheduledRoundsComponent implements OnInit {
  constructor(
    private api: ApiEntryControlService,
    private toast: ToastrService,
    private modal: NgbModal,
    private formBuilder: FormBuilder,
    private routeActive: ActivatedRoute,
    private snackBarService: MatSnackBar
  ) { }
  primaryForm: FormGroup;
  ngOnInit(): void {
    var data = this.routeActive.snapshot.params;
    if (data['id'] > 0) {
      this.sheduledId = data['id'];
      this.getData();
    }
    this.getFacilities();
    this.getRoundsType();


    this.primaryForm = this.formBuilder.group({
      id: [0, Validators.required],
      facility_id: [0, Validators.required],
      rounds_type_id: [0, Validators.required],
      start_date: [null, Validators.required],
      end_date: [null, Validators.required],
      image_path: [''],
      tags: [''],
      email_notification: []
    }, { validators: this.dateComparisonValidator });
  }
  /**
   * Hago referencia a la ventana actual
   */
  @Input()
  modalRef: NgbModalRef | undefined;

  sheduledId: number = 0;
  facility:Facility;

  @Output()
  success = new EventEmitter<boolean>();
  roundsConfiguration: RoundsConfiguration;
  facilities: Facility[];
  types: RoundsType[];
  tagsAvailable: RoundsTags[] = [];
  tagsSelected: RoundsTags[] = [];

  initMove: number;
  update() {

    // Convertir los IDs de los tags seleccionados a un string separado por comas
    const selectedTagIds = this.tagsSelected.map(tag => tag.id).join(',');
    this.primaryForm.get('tags')?.setValue(selectedTagIds);
    if (this.tagsSelected?.length <= 0) {
      this.toast.warning("Debe seleccionar al menos 1 tag");
      return;
    }
    this.api.updateRoundsConfiguration(this.primaryForm).subscribe(
      (rs) => {
        this.toast.success(rs.msg, 'Gestión Rondas');
        this.success.emit(true);
        if (this.modalRef != null) {
          this.modalRef.close();
        } else {
          this.modal.dismissAll();
        }
      },
      (error) => {
        this.toast.warning(error.error.mistakes, 'Tenemos un error');
      }
    );
  }
  getRoundsTags() {
    this.api.getAllTagsFacility(this.primaryForm.get('facility_id')?.value).subscribe(rs => {
      let tags = rs.data as RoundsTags[];
      this.tagsAvailable = tags.filter(tag => tag?.state_id != 2);
      this.normalizeTagsSelected(this.roundsConfiguration);
    });
  }
  normalizeTagsSelected(data: RoundsConfiguration) {
    data?.rounds_records.forEach(record => {
      const roundsTag = record.rounds_tags;
      this.tagsSelected.push(roundsTag);
      //elimino aquellos que ya estan cargados en el tagsSelected;
      const index = this.tagsAvailable.findIndex(tag => tag.id === roundsTag?.id);
      if (index !== -1) {
        this.tagsAvailable.splice(index, 1);
      }
    });
  }
  getData() {
    this.api.getRoundConfiguration(this.sheduledId).subscribe(rs => {
      this.roundsConfiguration = rs.data as RoundsConfiguration;
      this.primaryForm.patchValue(this.roundsConfiguration);
      this.primaryForm.get('facility_id')?.disable();
      this.primaryForm.get('rounds_type_id')?.disable();
      this.getFacility();
      this.getRoundsTags();
    });
  }

  getFacilities() {
    this.api.getAllFacility().subscribe(rs => {
      this.facilities = rs.data as Facility[];
    });
  }
  getFacility() {
    this.api.getFacility(this.primaryForm.get('facility_id')?.value).subscribe(rs => {
      this.facility = rs.data as Facility;
    });
  }
  getRoundsType() {
    this.api.getAllRoundsType().subscribe(rs => {
      let types = rs.data as RoundsType[];
      this.types = types.filter(t => t.id != 1);

    });
  }
  openModal(md: any, size = 'md') {
    this.modal.open(md, {
      size: size,
    });
  }
  // Validación personalizada para comparar las fechas y horas
  dateComparisonValidator(formGroup: FormGroup) {
    const startDatetime = formGroup.get('start_date').value;
    const endDatetime = formGroup.get('end_date').value;

    if (startDatetime && endDatetime && startDatetime >= endDatetime) {
      return { dateComparison: true };
    }

    return null;
  }


  handleImageError() {
    this.primaryForm?.get('image_path').setValue('assets/images/default.jpg'); // Cambiar la URL a la imagen por defecto
  }
  formatDateTime(date: Date): string {
    return formatDate(date, 'yy-MM-dd HH:mm:ss', 'en-US');
  }


}


